// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoginV2_wrapper__3WFr2"};